import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import styled, { keyframes } from 'styled-components';
import Header from './components/Header';
import PrimaryRatingSelector from './components/PrimaryRatingSelector';
import SecondaryStarSelectors from './components/SecondaryStarSelectors';
import WhySolvCheckboxes from './components/WhySolvCheckboxes';
import { colors } from '../../constants/colors';
import FreeResponseForm from './components/FreeResponseForm';
import { fontFamily, fontSize } from '../../constants/text';
import { analyticsTrackEvent } from '../../core/analytics';
import { ACTION_LOAD } from '../../core/analytics/events';
import { apiPostJson } from '../../core/dapi';
import { getTrackingUrl } from '../../core/dapi/tracking';
import { TRACKING_LOAD_MARY_MAGIC_SURVEY, MARY_MAGIC_SURVEY_EVENT } from './constants';

const Root = styled.div`
  width: 100%;
  text-align: center;
  background-color: ${colors.whiteGrey};
`;

const fill = keyframes`
  from {
    transform: scaleX(0);
  } to {
    transform: scaleX(1);
  }
`;

const ThanksForFeedback = styled.div`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.large};
  color: ${colors.greenHope};
  position: relative;
  margin: 180px auto 220px;
  display: inline-block;

  &:after {
    content: '';
    animation: ${fill} 4s linear 1;
    background-color: ${colors.greenHope};
    display: block;
    margin-top: 10px;
    height: 6px;
    width: 100%;
    transform-origin: left;
  }
`;

export default class MaryMagicSurvey extends PureComponent {
  static propTypes = {
    maryMagicSurvey: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    submit: PropTypes.func,
    clearMaryMagicSurvey: PropTypes.func,
  };

  componentDidMount = () => {
    const { accountId, market } = this.props.maryMagicSurvey;
    analyticsTrackEvent(MARY_MAGIC_SURVEY_EVENT, {
      action: ACTION_LOAD,
      accountId,
      market,
    });
    apiPostJson(getTrackingUrl('accounts', accountId, 'action.load'), {
      type: TRACKING_LOAD_MARY_MAGIC_SURVEY,
      market,
    });
  };

  componentWillUnmount = () => this.props.clearMaryMagicSurvey();

  handleSubmit = formData =>
    this.props.submit({
      ...formData,
      ...this.props.maryMagicSurvey,
    });

  render() {
    const { maryMagicSurvey, onChange } = this.props;
    return (
      <Root>
        <Header />
        <Collapse in={!maryMagicSurvey.thanksForFeedback} timeout="auto">
          <Fragment>
            <PrimaryRatingSelector maryMagicSurvey={maryMagicSurvey} onChange={onChange} />
            <SecondaryStarSelectors maryMagicSurvey={maryMagicSurvey} onChange={onChange} />
            <WhySolvCheckboxes maryMagicSurvey={maryMagicSurvey} onChange={onChange} />
            <FreeResponseForm maryMagicSurvey={maryMagicSurvey} submit={this.handleSubmit} />
          </Fragment>
        </Collapse>
        <Collapse in={!!maryMagicSurvey.thanksForFeedback} timeout="auto" mountOnEnter>
          <ThanksForFeedback>Thanks for the feedback!</ThanksForFeedback>
        </Collapse>
      </Root>
    );
  }
}
